import { IPermission } from './permission.interface';

export interface IGroup {
  id: number;
  name: string;
  slug: string;
  /**
   * Workflow role of the group (BE `acl_groups.role`). Distinct from `slug`:
   * the pilot group has `slug: 'rm-pilot'` but `role: 'rm'`, so it acts as the
   * RM workflow role while staying a separate permission-group identity. This is
   * the single source of role identity — prefer it over the legacy `tag`.
   */
  role: string;
  tag: string[];
  scope: 'bu' | 'own';
  permissions: IPermission[];
  viewPolicy?: {
    policy: string[];
  };
}

// Use in the internal user list (viewGroup entity) and GET list view group api
export interface IViewGroup {
  id: number;
  name: string;
  slug: string;
  status: string;
  groups: IGroup[];
  viewPolicy: {
    policy: string[];
  };
}
